import React, { useState } from "react";

import { Button, Divider, Input, Row } from "antd";
import moment from "moment";

const InquiryComponent = ({
  inquiryData,
  total,
  currIdx,
  registerInquiryAnswer,
  deleteAnswerBtnClick,
}) => {
  const [isAnswerContentOpen, setIsAnswerContentOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [answer, setAnswer] = useState(null);

  const answerContentOpenBtnClick = () => {
    setIsAnswerContentOpen(!isAnswerContentOpen);
  };

  const editBtnClick = (answerBody) => {
    setAnswer(answerBody);
    setEdit(true);
  };

  const editCancelBtnClick = () => {
    setEdit(false);
    setAnswer(null);
  };

  const disabledBtn = () => {
    if (answer) {
      if (answer?.length === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <div className="inquiry-component-wrap">
      <div
        className="inquiry-ask-wrap"
        style={{
          borderBottom:
            total === currIdx + 1
              ? 0
              : isAnswerContentOpen
              ? 0
              : "solid 1px #ced4da",
        }}
      >
        <img
          className="product-img-wrap"
          src={`${process.env.REACT_APP_S3_HOST}/image/recommend/${inquiryData.target_id}.jpg`}
        />
        <div className="inquiry-ask-content-wrap">
          <div className="inquiry-ask-title-wrap">
            <div className="inquiry-ask-product-name">
              {inquiryData.product_name}
            </div>
            {inquiryData.is_show && (
              <img
                className="inquiry-ask-secret-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/secret_icon.png`}
              />
            )}
            {inquiryData.answer_status === 1 ? (
              <div className="answer-status-wrap answered">답변완료</div>
            ) : (
              <div className="answer-status-wrap unanswered">답변대기</div>
            )}
          </div>
          <div className="inquiry-ask-subtitle-wrap">
            {inquiryData.product_brand_name}
            <div className="separator"></div>
            {inquiryData.created_by_name}
            <div className="separator"></div>
            {moment(inquiryData.created_at).format("YYYY.MM.DD HH:mm")}
          </div>
          <div className="inquiry-ask-body-wrap">{inquiryData.ask_body}</div>
          <div
            className="inquiry-answer-expand-button"
            onClick={answerContentOpenBtnClick}
          >
            답글
            <span className="inquiry-answer-number">
              {inquiryData.answer_status}
            </span>
            <img
              className="inquiry-answer-expand-icon"
              src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/${
                isAnswerContentOpen ? "up" : "down"
              }_icon.png`}
            />
          </div>
        </div>
      </div>
      {isAnswerContentOpen ? (
        <div className="inquiry-answer-wrap">
          {inquiryData.answer_status === 0 || edit ? (
            <div className="inquiry-answer-input-box-wrap">
              {edit ? (
                <div className="inquiry-answer-input-edit-box-wrap">
                  <Row>
                    <img
                      className="inquiry-answer-comment-icon"
                      src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/answer_comment_icon.png`}
                    />
                    <div className="inquiry-answer-date">
                      {moment(inquiryData.answer_updated_at).format(
                        "YYYY.MM.DD HH:mm",
                      )}
                    </div>
                  </Row>
                  <div
                    onClick={editCancelBtnClick}
                    style={{ cursor: "pointer" }}
                  >
                    수정취소
                  </div>
                </div>
              ) : null}
              <div className="inquiry-answer-input-wrap">
                <Input.TextArea
                  showCount
                  allowClear={true}
                  maxLength={1000}
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                  placeholder="답글을 입력해 주세요."
                />
                <Button
                  className="inquiry-answer-button"
                  disabled={disabledBtn()}
                  onClick={() => {
                    if (edit) {
                      registerInquiryAnswer(
                        inquiryData,
                        answer,
                        "edit",
                        answerContentOpenBtnClick,
                        editCancelBtnClick,
                      );
                    } else {
                      registerInquiryAnswer(
                        inquiryData,
                        answer,
                        "create",
                        answerContentOpenBtnClick,
                      );
                    }
                  }}
                >
                  {edit ? "수정" : "등록"}
                </Button>
              </div>
              <Divider className="product-register-form-input-divider" />
            </div>
          ) : (
            <div className="inquiry-answer-box-wrap">
              <img
                className="inquiry-answer-comment-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/answer_comment_icon.png`}
              />
              <div className="inquiry-answer-content-wrap">
                <div className="inquiry-answer-date">
                  {moment(inquiryData.answer_updated_at).format(
                    "YYYY.MM.DD HH:mm",
                  )}
                </div>
                <div className="inquiry-answer-body-wrap">
                  {inquiryData.answer_body}
                  <img
                    className="inquiry-answer-button"
                    src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/edit_pencil.png`}
                    style={{ marginLeft: 7, marginRight: 7 }}
                    onClick={() => editBtnClick(inquiryData.answer_body)}
                  />
                  <img
                    className="inquiry-answer-button"
                    src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/delete_icon.png`}
                    onClick={() => deleteAnswerBtnClick(inquiryData)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default InquiryComponent;
